import React, { useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Space,
  Row,
  Col,
  Select,
} from 'antd';

const { TextArea } = Input;
const { Option } = Select;

const StoreDepartmentForm = ({
  initialValues,
  onSubmit,
  onCancel,
  stores = [],
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);

  const handleSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
    >
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="name"
            label="Name"
            rules={[{ required: true, message: 'Please enter department name' }]}
          >
            <Input placeholder="Enter department name" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="code"
            label="Code"
            rules={[{ required: true, message: 'Please enter department code' }]}
          >
            <Input placeholder="Enter department code" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            name="storeId"
            label="Store"
            rules={[{ required: true, message: 'Please select a store' }]}
          >
            <Select placeholder="Select a store">
              {stores.map(store => (
                <Option key={store.id} value={store.id}>{store.name}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        name="description"
        label="Description"
      >
        <TextArea
          placeholder="Enter department description"
          rows={4}
        />
      </Form.Item>

      <Form.Item>
        <Space>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
          <Button onClick={onCancel}>Cancel</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default StoreDepartmentForm;
